<NavLink
  v-if="isFetchComplete"
  v-for="link in navLinks"
  :id="link.id"
  :key="link.id"
  :label="link.label || ''"
  :route="link.route"
  :classes="link.classes"
  :type="navbarType"
/>
